module.exports = __webpack_public_path__ + "static/media/cancel-red.18a3d0f8.svg";